import { render, staticRenderFns } from "./allUserList.vue?vue&type=template&id=18bd3d4e&scoped=true&"
import script from "./allUserList.vue?vue&type=script&lang=js&"
export * from "./allUserList.vue?vue&type=script&lang=js&"
import style0 from "./allUserList.vue?vue&type=style&index=0&id=18bd3d4e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bd3d4e",
  null
  
)

export default component.exports